import {
  SlSpinner
} from "./chunk.J2B3BBYS.js";

// src/components/spinner/spinner.ts
var spinner_default = SlSpinner;
SlSpinner.define("sl-spinner");

export {
  spinner_default
};
